export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const TOGGLE_CART_DRAWER = "TOGGLE_CART_DRAWER";
export const HANDLE_CLICK_FROM_PRODUCT = "HANDLE_CLICK_FROM_PRODUCT";
export const HANDLE_CLICK_FROM_CATEGORY = "HANDLE_CLICK_FROM_CATEGORY";
export const HANDLE_CLICK_FROM_HOMESCREEN = "HANDLE_CLICK_FROM_HOMESCREEN";
export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const API_ERROR = "API_ERROR";
export const API_SUCCESS = "API_SUCCESS";
